webpackJsonp([6121521954879],{

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement('html', { lang: 'en' }),
	            _react2.default.createElement(
	                'title',
	                null,
	                'Immediate Help - Crisis Line'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'If you are in crisis or danger, please use the following resources to get immediate help.' })
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { style: { maxWidth: 700, margin: 'auto', padding: '40px 15px' } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { textAlign: 'center' } },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Need Help?'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { style: { fontWeight: 300 } },
	                        'If you are in crisis or danger, please use the following resources to get immediate help.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { padding: 20, boxShadow: '0 1px 4px 0 rgba(205,205,205,0.8' } },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Canada'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { style: { color: '#e8006b' } },
	                        '911  ',
	                        _react2.default.createElement(
	                            'span',
	                            { style: { paddingLeft: 20 } },
	                            'Emergency'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '+1 (888) 353-2273  ',
	                        _react2.default.createElement(
	                            'span',
	                            { style: { paddingLeft: 20 } },
	                            'Hotline'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { target: '_blank', href: 'http://www.yourlifecounts.org/need-help/crisis-lines' },
	                            'YourLifeCounts.org'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-en-crisis-line-js-1f7659bdcde27dabfe16.js